<template>
  <oct-dialog
    full
    :title="category ? category.name : ''"
    :icon="'arrow-left'"
    @dismiss="$_octPrototypeView_goBack"
    class="ss-product-selector"
  >
    <div>
      <!-- Available Items -->
      <section>
        <!-- Product List -->
        <oct-list
          title="商品を選択"
        >
          <oct-list-item
            v-for="item in items"
            :key="item.id"
            v-bind="item"
            dense
            @click.native="submit(item)"
          >
          </oct-list-item>
        </oct-list>
      </section>

      <!-- Discontinued Items -->
      <section
        v-if="discontinuedItems.length"
        class="ss-product-selector-section--secondary"
      >
        <!-- Header -->
        <div
          class="ss-product-selector-section-header"
          @click="$_ssProductSelector_toggleDiscontinuedItems"
        >
          <div class="ss-product-selector-section-header__text">
            <!-- Title -->
            <h2 class="ss-product-selector-section-header__title">
              販売終了アイテム
            </h2>

            <!-- Description -->
            <p class="ss-product-selector-section-header__description">
              以下アイテムは販売終了アイテムとなり、milbon iDでは取り扱いをしていないアイテムになります。
            </p>
          </div>

          <!-- Action Icon -->
          <oct-icon
            icon="chevron-right"
            class="ss-product-selector-section-header__icon"
            :style="{
              transform: $data.$_ssProductSelector_showDiscontinuedItems ? 'rotate(270deg)' : undefined
            }"
          />
        </div>

        <!-- Product List -->
        <oct-list
          v-if="$data.$_ssProductSelector_showDiscontinuedItems"
        >
          <oct-list-item
            v-for="item in discontinuedItems"
            :key="item.id"
            v-bind="item"
            dense
            @click.native="submit(item)"
          >
          </oct-list-item>
        </oct-list>
      </section>
    </div>
  </oct-dialog>
</template>

<script>
import OctIcon from '@/components/icon/OctIcon.vue';
import OctList from '@/components/list/OctList.vue'
import OctListItem from '@/components/list/OctListItem.vue'
import OctDialog from '@/components/dialog/OctDialog.vue'
import OctPrototypeView from '@/mixins/OctPrototypeView.js'

export default {
  name: 'SSProductSelector',
  mixins: [
    OctPrototypeView
  ],
  components: {
    OctIcon,
    OctList,
    OctListItem,
    OctDialog
  },
  props: {
    /** Treatment ID */
    treatmentId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    /** Indicate to show discontinued items */
    $_ssProductSelector_showDiscontinuedItems: false
  }),
  computed: {
    /** Target treatment */
    item: vm => vm.$store.getters['treatments/byId'](vm.treatmentId),
    /** Available items */
    items () {
      return this.$store.getters['products/products'](this.$route.params.categoryId, this.$route.params.brandId)
        .filter(item => !item.discontinued)
        .map(item => this.productToListItem(item))
    },
    /** Discontinued items */
    discontinuedItems () {
      return this.$store.getters['products/products'](this.$route.params.categoryId, this.$route.params.brandId)
        .filter(item => item.discontinued)
        .map(item => this.productToListItem(item))
    },
    category () {
      return this.$store.getters['products/categoryById'](this.$route.params.categoryId)
    }
  },
  methods: {
    submit (item) {
      // Index to insert to others array
      const index = this.$route.query.index
      // Prop to update
      const prop = this.$route.query.prop
      // Other products
      const others = this.item.others

      // Case of recommended item
      if (prop === 'recommended') {
        console.warn(item)
        // Commit new item
        this.$store.dispatch('treatments/set', {
          items: [
            {
              id: this.item.id,
              data: {
                recommendedItem: {
                  item: item.id
                }
              }
            }
          ]
        })
      } else { // Other cases
        // Update others if necessary
        prop === 'others' &&
          (index != -1 ? others.splice(index, 1, item.id) : others.push(item.id))

        // Commit new item
        this.$store.dispatch('treatments/set', {
          items: [
            Object.assign(
              {
                id: this.item.id
              },
              prop === 'others' ? {
                others: others
              } : {
                [prop]: item.id
              }
            )
          ]
        })
      }

      this.$_octPrototypeView_goBack(prop === 'others' || prop === 'recommended' ? -3 : -2)
    },
    /** Toggle to show discontinued items */
    $_ssProductSelector_toggleDiscontinuedItems () {
      this.$data.$_ssProductSelector_showDiscontinuedItems = !this.$data.$_ssProductSelector_showDiscontinuedItems
    }
  }
}
</script>

<style scoped lang="scss">
@import "../components/theme/variables";
@import "../components/grid/variables";
@import "../components/typography/variables";
@import "../components/typography/mixins";

.ss-product-selector {
  ::v-deep .oct-dialog-header {
    margin-bottom: oct-rem(32);
  }
}

.ss-product-selector-section--secondary {
  margin: 0 oct-rem(-16) oct-rem(32);
  padding: 0 oct-rem(16);
  background-color: $oct-theme--neutral-10;
  overflow: hidden;
}

.ss-product-selector-section-header {
  display: flex;
  gap: oct-rem(16);
  align-items: center;
  padding: oct-rem(32) 0;
  cursor: pointer;
}

.ss-product-selector-section-header__text {
  color: $oct-theme--neutral-50;
  display: flex;
  flex-direction: column;
  gap: oct-rem(12);
}

.ss-product-selector-section-header__title {
  font-size: oct-rem(16);
  line-height: 1;
}

.ss-product-selector-section-header__description {
  font-size: oct-rem(12);
  line-height: 1.5;
}

.ss-product-selector-section-header__icon {
  flex: 0 0 auto;
  display: block;
  width: oct-rem(32);
  height: oct-rem(32);
  transform: rotate(90deg);
  fill: $oct-theme--neutral-50;
  transition-duration: 0.3s;
}
</style>